import { isLength } from 'validator';

export function maxLength(length) {
  return fieldName => (value = '') =>
    isLength(value || '', { max: length })
      ? undefined
      : `${fieldName} must be at most ${length} characters long`;
}
